(function () {
  'use strict';

  var VERSION = '1.0.0';
  var script = document.currentScript;
  var root = document.documentElement;

  if (window.__vdAnalyticsEngagementLoaded) return;
  window.__vdAnalyticsEngagementLoaded = true;

  var config = {
    measurementId: script && script.dataset.vdGa4Id || '',
    pageType: script && script.dataset.vdPageType || 'unknown',
    productId: script && script.dataset.vdProductId || '',
    productHandle: script && script.dataset.vdProductHandle || '',
    productVendor: script && script.dataset.vdProductVendor || '',
    preview: /^\/t\/\d+\//.test(location.pathname) || /(?:^|[?&])preview_theme_id=/.test(location.search)
  };

  var qa = {
    version: VERSION,
    consent: 'pending',
    started: false,
    measurementId: config.measurementId,
    pageType: config.pageType,
    preview: config.preview,
    sectionCount: 0,
    eventsQueued: 0,
    lastEvent: null
  };

  window.__vdAnalyticsQA = qa;
  root.dataset.vdAnalyticsVersion = VERSION;

  function syncQa() {
    root.dataset.vdAnalyticsState = qa.consent;
    root.dataset.vdAnalyticsStarted = qa.started ? '1' : '0';
    root.dataset.vdAnalyticsSections = String(qa.sectionCount);
    root.dataset.vdAnalyticsEvents = String(qa.eventsQueued);
    root.dataset.vdAnalyticsLastEvent = qa.lastEvent ? qa.lastEvent.name : '';
  }

  syncQa();

  function clean(value, maxLength) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength || 100);
  }

  function safePath(value) {
    try {
      var parsed = new URL(value, location.origin);
      return clean(parsed.pathname || '/', 100);
    } catch (error) {
      return '/';
    }
  }

  function sameOriginReferrerPath() {
    if (!document.referrer) return '';
    try {
      var parsed = new URL(document.referrer);
      return parsed.origin === location.origin ? clean(parsed.pathname, 100) : '';
    } catch (error) {
      return '';
    }
  }

  function externalReferrerHost() {
    if (!document.referrer) return '';
    try {
      var parsed = new URL(document.referrer);
      return parsed.origin === location.origin ? '' : clean(parsed.hostname, 100);
    } catch (error) {
      return '';
    }
  }

  function sessionGet(key) {
    try {
      return sessionStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function sessionSet(key, value) {
    try {
      sessionStorage.setItem(key, String(value));
    } catch (error) {
      // Analytics continues without the optional path counter.
    }
  }

  function canTrack() {
    try {
      return !!(
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function baseParams() {
    var params = {
      page_type: clean(config.pageType, 40),
      current_path: safePath(location.href)
    };

    if (config.productId) params.product_id = clean(config.productId, 50);
    if (config.productHandle) params.product_handle = clean(config.productHandle, 100);
    if (config.productVendor) params.product_vendor = clean(config.productVendor, 100);
    if (config.preview) params.debug_mode = true;

    return params;
  }

  function ensureGtag() {
    if (!config.measurementId) return false;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    if (!window.__vdAnalyticsGtagConfigured) {
      window.__vdAnalyticsGtagConfigured = true;
      window.gtag('js', new Date());
      window.gtag('config', config.measurementId, {
        send_page_view: false
      });
    }

    return true;
  }

  function send(eventName, params) {
    if (!canTrack() || !ensureGtag()) return false;

    var payload = Object.assign(baseParams(), params || {}, {
      transport_type: 'beacon'
    });

    window.gtag('event', eventName, payload);
    qa.eventsQueued += 1;
    qa.lastEvent = {
      name: eventName,
      params: payload,
      at: new Date().toISOString()
    };
    syncQa();

    if (config.preview && window.console && console.info) {
      console.info('[Verdiance analytics QA]', eventName, payload);
    }

    return true;
  }

  function navigationType() {
    try {
      var entries = performance.getEntriesByType('navigation');
      return clean(entries[0] && entries[0].type || 'navigate', 30);
    } catch (error) {
      return 'navigate';
    }
  }

  function trackPathStep() {
    var currentPath = safePath(location.href);
    var previousPath = sessionGet('vd_previous_path') || sameOriginReferrerPath();
    var priorIndex = parseInt(sessionGet('vd_path_index'), 10);
    var pathIndex = Number.isFinite(priorIndex) ? priorIndex + 1 : 1;

    sessionSet('vd_path_index', pathIndex);
    sessionSet('vd_previous_path', currentPath);

    send('visitor_path_step', {
      previous_path: clean(previousPath, 100),
      path_index: pathIndex,
      referrer_host: externalReferrerHost(),
      navigation_type: navigationType()
    });

    return pathIndex;
  }

  function sectionKey(element) {
    var id = element.id || '';

    if (/^v10-product-info-/.test(id)) return 'product_summary';
    if (/^v10-object-/.test(id)) return 'object_story';
    if (/^v10-proportions-/.test(id)) return 'dimensions';
    if (/^v10-material-/.test(id)) return 'materials';
    if (/^v10-design-/.test(id)) return 'characteristics';
    if (/^v10-living-/.test(id)) return 'daily_use';
    if (/^v10-complements-/.test(id)) return 'complementary_products';
    if (/^v10-fiche-/.test(id)) return 'details';
    if (/^v10-regard-/.test(id)) return 'verdiance_view';
    if (element.querySelector('[id^="v10-priority-title-"]')) return 'essentials';
    if (element.matches('.v9p-related')) return 'related_products';
    return '';
  }

  function collectPdpSections() {
    var candidates = [];
    var summary = document.querySelector('main [id^="v10-product-info-"]');
    var priorityTitle = document.querySelector('main [id^="v10-priority-title-"]');
    var priority = priorityTitle && priorityTitle.closest('section');

    if (summary) candidates.push(summary);
    if (priority) candidates.push(priority);

    document.querySelectorAll(
      'main section[id^="v10-object-"], ' +
      'main section[id^="v10-proportions-"], ' +
      'main section[id^="v10-material-"], ' +
      'main section[id^="v10-design-"], ' +
      'main section[id^="v10-living-"], ' +
      'main section[id^="v10-complements-"], ' +
      'main section[id^="v10-fiche-"], ' +
      'main section[id^="v10-regard-"], ' +
      'main section.v9p-related'
    ).forEach(function (element) {
      candidates.push(element);
    });

    return Array.from(new Set(candidates))
      .filter(function (element) { return !!sectionKey(element); })
      .sort(function (left, right) {
        return left.compareDocumentPosition(right) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
  }

  function normalizedVisibility(rect) {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    var denominator = Math.max(1, Math.min(rect.width, viewportWidth) * Math.min(rect.height, viewportHeight));
    return Math.max(0, Math.min(1, visibleWidth * visibleHeight / denominator));
  }

  function observePdpSections(pathIndex) {
    if (config.pageType !== 'product' || !('IntersectionObserver' in window)) return;

    var sections = collectPdpSections();
    qa.sectionCount = sections.length;
    syncQa();
    if (!sections.length) return;

    var states = new Map();

    sections.forEach(function (element, index) {
      var key = sectionKey(element);
      var observationTarget = (
        key === 'product_summary' &&
        window.getComputedStyle(element).display === 'contents' &&
        element.firstElementChild
      ) || element;
      var heading = element.querySelector('h1, h2, h3');
      states.set(observationTarget, {
        key: key,
        label: clean(heading && heading.textContent, 100),
        index: index + 1,
        ratio: 0,
        maxRatio: 0,
        activeAt: null,
        accumulatedMs: 0,
        exposureIndex: 0
      });
    });

    function pause(state) {
      if (state.activeAt === null) return;
      state.accumulatedMs += Math.max(0, performance.now() - state.activeAt);
      state.activeAt = null;
    }

    function emitExposure(state, force) {
      pause(state);
      if (state.accumulatedMs < 1000 && !force) return;
      if (state.accumulatedMs < 1000) return;

      state.exposureIndex += 1;
      send('pdp_section_engagement', {
        section_key: state.key,
        section_label: state.label,
        section_index: state.index,
        section_exposure_index: state.exposureIndex,
        engagement_ms: Math.round(state.accumulatedMs),
        max_visibility_pct: Math.round(state.maxRatio * 100),
        path_index: pathIndex
      });

      state.accumulatedMs = 0;
      state.maxRatio = 0;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = states.get(entry.target);
        if (!state) return;

        var ratio = normalizedVisibility(entry.boundingClientRect);
        state.ratio = ratio;
        state.maxRatio = Math.max(state.maxRatio, ratio);

        if (ratio >= 0.5 && document.visibilityState === 'visible') {
          if (state.activeAt === null) state.activeAt = performance.now();
        } else if (state.activeAt !== null) {
          pause(state);
          emitExposure(state, false);
        }
      });
    }, {
      threshold: [0, 0.02, 0.05, 0.1, 0.15, 0.25, 0.5, 0.75, 1]
    });

    states.forEach(function (_, element) {
      observer.observe(element);
    });

    function flushVisibleSections() {
      states.forEach(function (state) {
        if (state.activeAt !== null) emitExposure(state, true);
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        flushVisibleSections();
      } else {
        states.forEach(function (state) {
          if (state.ratio >= 0.5 && state.activeAt === null) state.activeAt = performance.now();
        });
      }
    });

    window.addEventListener('pagehide', flushVisibleSections, { once: true });

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href^="#v10-"]');
      if (!link) return;

      var target = document.querySelector(link.getAttribute('href'));
      var section = target && (target.matches('section') ? target : target.closest('section'));
      var key = section && sectionKey(section);
      if (!key) return;

      send('pdp_section_navigate', {
        section_key: key,
        path_index: pathIndex
      });
    });
  }

  function start() {
    if (qa.started || !canTrack()) return;
    qa.started = true;
    qa.consent = 'granted';
    syncQa();

    var pathIndex = trackPathStep();
    observePdpSections(pathIndex);
  }

  function evaluateConsent() {
    qa.consent = canTrack() ? 'granted' : 'denied';
    syncQa();
    if (canTrack()) start();
  }

  function loadPrivacyApi() {
    if (window.Shopify && Shopify.customerPrivacy) {
      evaluateConsent();
      return;
    }

    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function (error) {
        if (error) {
          qa.consent = 'privacy_api_error';
          syncQa();
          return;
        }
        evaluateConsent();
      });
      return;
    }

    qa.consent = 'privacy_api_unavailable';
    syncQa();
  }

  document.addEventListener('visitorConsentCollected', evaluateConsent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPrivacyApi, { once: true });
  } else {
    loadPrivacyApi();
  }
}());
